/* eslint-disable-jsx-a11y/anchor-is-valid*/
import React from 'react'
import {Grid,} from '@material-ui/core'
import {listDefaults} from './config'
import AppButton from '../Common/AppButton'
import MUIDataTables from 'mui-datatables'
import { colors } from '../../shared/colors';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';


export default function UploadFilesList(props){

    const {removeFileUploadAction, title} = listDefaults

    const {
            listProps:{
                files, 
                removeFile,
                header=title,
                deleteIcon=removeFileUploadAction.icon,
            }
        } = props
    
    const _header = props.header || header
    const _deleteIcon = props.deleteIcon || deleteIcon

    const getMuiTheme = () => createMuiTheme({
        overrides: {
            MUIDataTableHeadCell: {
                root: {
                    display: "none",
                },
            },
        }
    })

    const deleteAction = index =>  {
        return (
            <AppButton 
                {...removeFileUploadAction}
                label="Remove File"
                icon={_deleteIcon}
                onClick={removeFile ? ()=>removeFile(index) : null}
            />
        )
    }

    const data = files.map( (file, index) => ({index: `${index + 1}.`, name: file.name, action: deleteAction(index)}) )

    const columns = [
        {
         name: "index",
        },
        {
         name: "name",
        },
        {
         name: "action",
        },
    ];

    const tableOptions = {
        print: false,
        download: false,
        viewColumns: false,
        filter: false,
        search: false,
        selectableRows: 'none',
        responsive: 'scrollMaxHeight',
        pagination: false,
        fixedHeader: false,
        setRowProps: (row, index) => {
            if(index % 2 === 0){
                return({
                    style: {backgroundColor: colors.magellanLightGray}
                })
            }
        }
    }

    const filesList =  (
        <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTables
                title={_header}
                data={data}
                columns={columns}
                options={tableOptions}
            />
        </MuiThemeProvider>
    )

    return (
        <Grid container item xs={12}>
            { files.length > 0 &&
                <div style={{width: 'inherit'}}>
                    {filesList}
                </div>
            }
        </Grid>
    )
}